import Cropper from 'react-easy-crop';

const CropperMultipleComponent = ({
  itemObject,
  onCropChangeFunction,
  onCropCompleteFunction,
  onZoomChangeFunction,
}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <Cropper
        zoomWithScroll={false}
        showGrid={false}
        image={itemObject.imageSrc}
        crop={itemObject.crop}
        zoom={itemObject.zoom}
        // cropSize={{
        //     width: overlayWidth - 5,
        //     height: overlayHeight - 5,
        // }}
        onCropChange={onCropChangeFunction}
        onCropComplete={onCropCompleteFunction}
        onZoomChange={onZoomChangeFunction}
        objectFit="contain"
      />
    </div>
  );
};

export default CropperMultipleComponent;
